import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const P = (projectId) => `${API}/projects/${projectId}`;
export const panoFileUrl = (projectId, panoId) => `${P(projectId)}/panoramas/${panoId}/file`;

// yaw/pitch (radians, panorama-relative) -> viewer lon/lat degrees (orientation only, not world coords)
export const coordToView = (coord, fov = 60) =>
  coord && typeof coord.yaw === 'number'
    ? { lon: (coord.yaw * 180) / Math.PI, lat: (coord.pitch * 180) / Math.PI, fov }
    : null;

export const sw = {
  coverageCapture: (pid, params) => axios.get(`${P(pid)}/sitewalk-coverage/capture`, { params }).then((r) => r.data),
  coverageSchedule: (pid) => axios.get(`${P(pid)}/sitewalk-coverage/schedule`).then((r) => r.data),
  coverageEvidence: (pid) => axios.get(`${P(pid)}/sitewalk-coverage/evidence`).then((r) => r.data),
  staleness: (pid, params) => axios.get(`${P(pid)}/sitewalk-coverage/staleness`, { params }).then((r) => r.data),
  resolve: (pid, params) => axios.get(`${P(pid)}/sitewalk-resolve`, { params }).then((r) => r.data),
  evidenceActivity: (pid, id) => axios.get(`${P(pid)}/sitewalk-evidence/activity/${id}`).then((r) => r.data),
  evidenceBoqItem: (pid, id) => axios.get(`${P(pid)}/sitewalk-evidence/boq-item/${id}`).then((r) => r.data),
  evidenceBimElement: (pid, id) => axios.get(`${P(pid)}/sitewalk-evidence/bim-element/${id}`).then((r) => r.data),
  evidenceIssue: (pid, id) => axios.get(`${P(pid)}/sitewalk-evidence/issue/${id}`).then((r) => r.data),
  evidenceObservation: (pid, kind, id) => axios.get(`${P(pid)}/sitewalk-evidence/observation/${kind}/${id}`).then((r) => r.data),
  walks: (pid, params) => axios.get(`${P(pid)}/site-walks`, { params }).then((r) => r.data),
  shares: (pid, wid) => axios.get(`${P(pid)}/site-walks/${wid}/shares`).then((r) => r.data),
  share: (pid, wid, body) => axios.post(`${P(pid)}/site-walks/${wid}/share`, body).then((r) => r.data),
  revoke: (pid, wid, body) => axios.post(`${P(pid)}/site-walks/${wid}/share/revoke`, body).then((r) => r.data),
  aiProposals: (pid, params) => axios.get(`${P(pid)}/sitewalk-ai/proposals`, { params }).then((r) => r.data),
  aiStats: (pid) => axios.get(`${P(pid)}/sitewalk-ai/stats`).then((r) => r.data),
  reportUrl: (pid, type, fmt, params = {}) => {
    const q = new URLSearchParams(params).toString();
    return `${P(pid)}/sitewalk-reports/${type}.${fmt}${q ? `?${q}` : ''}`;
  },
  parties: (pid) => axios.get(`${P(pid)}/parties`).then((r) => r.data).catch(() => ({ items: [] })),
};

export const REGISTRATION_LABEL = {
  FLOOR_PLAN_POSITIONED: 'Floor-plan positioned',
  CONTEXT_LINKED: 'Context-linked',
  SPATIALLY_REGISTERED: 'Spatially registered',
  GEOMETRICALLY_REGISTERED: 'Geometrically registered',
};
